module.exports = __webpack_public_path__ + "static/media/step10.8d028a73.png";